"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _dayjs = _interopRequireDefault(require("dayjs"));

var _hadate = require("../../../helpers/hadate");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var publishedDateTSBuilder = function publishedDateTSBuilder(params) {
  var publishedBeforeHrs = params.publishedBeforeHrs;

  if (!publishedBeforeHrs) {
    return '';
  } // current time but with 0 mins, 0 secs, and 0 ms


  var currentDateTime = (0, _dayjs["default"])().startOf('hour').toISOString();
  var publishedDate = (0, _hadate.addHours)(currentDateTime, -publishedBeforeHrs);
  var publishedDateTS = (0, _hadate.dateToTimestamp)(new Date(publishedDate));
  return "publishedDateTS>" + publishedDateTS;
};

var _default = publishedDateTSBuilder;
exports["default"] = _default;